import React, { useState } from "react";

// icons
import { FaMobileAlt, FaTabletAlt, FaDesktop } from "react-icons/fa";

const Step2: React.FC<{ ChangeStep: Function }> = ({ ChangeStep }) => {
  return (
    <>
      <div className="desk-only">
        <div className="s1">
          <h2>Select a device type</h2>
          <div className="s1-flex">
            <div
              className="s1-item"
              onClick={() => {
                ChangeStep();
              }}
            >
              <div className="s1-item_icon">
                <FaMobileAlt />
              </div>
              <p>SMART PHONE</p>
            </div>
            <div
              className="s1-item"
              onClick={() => {
                ChangeStep();
              }}
            >
              <div className="s1-item_icon">
                <FaTabletAlt />
              </div>
              <p>TABLET</p>
            </div>
            <div
              className="s1-item"
              onClick={() => {
                ChangeStep();
              }}
            >
              <div className="s1-item_icon">
                <FaDesktop />
              </div>
              <p>COMPUTER</p>
            </div>
          </div>
        </div>
      </div>
      <div className="mob-only"></div>
    </>
  );
};

export default Step2;
